import React, { useState, useEffect } from 'react';

interface ClientOnlyProps {
  children: React.ReactNode;
}

/**
 * ClientOnlyコンポーネント
 * 
 * SSR時と初回ハイドレーション時は何もレンダリングせず、
 * クライアント側でマウント完了後にのみ子要素をレンダリングする。
 * 
 * これにより、SSRとクライアント側でDOM構造が一致し、
 * ハイドレーションエラーを防ぐことができる。
 * 
 * @param children - クライアント側でのみレンダリングする子要素
 */
const ClientOnly: React.FC<ClientOnlyProps> = ({ children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return <>{children}</>;
};

export default ClientOnly;


